// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./images/Pmap.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Flavors&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Section Styles */
.section.num3 {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: none;
  padding: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 100vh;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}
.knife {
  position: absolute;
  pointer-events: none;
  width: 80px;
  transform-origin: bottom center;
  transition: transform 0.3s ease;
  z-index: 10001;
}

@keyframes knife-wave {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(-20deg);
  }
  50% {
    transform: rotate(20deg);
  }
  100% {
    transform: rotate(0deg);
  }
}

.knife.wave {
  animation: knife-wave 0.3s ease;
}
  
.scroll-container {
  position: absolute; /* Use absolute positioning */
  width: 80%;
  max-width: 600px;
  top: 0;
  height: 40%;
  left: 50%; /* Center horizontally */
  transform: translateX(-50%); /* Adjust centering */
  z-index: 5;
  margin: 0; /* Remove any existing margin */
}

  
  .scroll-image {
    width: 100%;
    height: 35%;
    display: block;
    object-fit: top;
  }
  
  .scroll-title {
    position: absolute;
    top: 20%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-family: 'Times New Roman', serif;
    font-size: 150%;
    font-weight: bold;
    color: #5e3a1f;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
    text-align: center;
  }
  
  /* Symbol and Title Styles */
  .symbol-container {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    z-index: 7;
  }
  
  .symbol-title {
    margin-bottom: 5px;
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    background-color: #8b0000;
    padding: 4px 8px;
    border-radius: 8px;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  }
  .x-symbol {
    font-family: "Flavors", cursive;
    font-weight: 400;
    font-style: normal;
    font-size: 45px;
    color: #fff;
    background-color: #8b0000;
    width: 70px;
    height: 70px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  }
  
  /* SVG and Red Curves */
  .svg-container {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    pointer-events: none;
    z-index: 5;
  }
  
  .red-curve {
    fill: none;
    stroke: #ff4500;
    stroke-width: 6;
    stroke-dasharray: 4, 6;
    stroke-opacity: 1;
    filter: drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.7));
    transition: d 0.2s ease-in-out;
  }
  
  /* Media Queries for Responsive Design */
  @media (max-width: 768px) {
    .symbol-title {
      font-size: 14px;
      padding: 4px 8px;
    }
  
    .x-symbol {
      font-size: 40px;
      width: 50px;
      height: 50px;
    }
  }
  
  .popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .popup-card {
    background: #121827;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
    text-align: center;
    position: relative;
    color: #555;
    font-size: 18px;
  }
  
  .popup-card h2 {
    margin-bottom: 10px;
    color: #E4B300;
    font-size: 34px;
  }

  .popup-card h3{
    color: #fff;
    margin-bottom: 5px;
  }
  
  .popup-image {
    width: 400px;
    height: auto;
    margin-bottom: 10px;
    border-radius: 10px;
    border: 2px solid #E4B300;
  }
  
  .popup-card button {
    background-color: #F4CC00;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 5px;
    margin-top: 5px;
  }
  
  .popup-card button:hover {
    background-color: #E4B300;
  }
  
  .ship {
    position: absolute;
    width: 100px;
    transform: translate(-50%, -50%) translateY(-50px); /* Keeps the height fixed */
    z-index: 20;
    animation: ship-sway 2s ease-in-out infinite; /* Sway animation */
  }
  
  @keyframes ship-sway {
    0% {
      transform: translate(-50%, -50%) translateY(-50px) rotate(0deg);
    }
    25% {
      transform: translate(-50%, -50%) translateY(-50px) rotate(-10deg);
    }
    50% {
      transform: translate(-50%, -50%) translateY(-50px) rotate(0deg);
    }
    75% {
      transform: translate(-50%, -50%) translateY(-50px) rotate(10deg);
    }
    100% {
      transform: translate(-50%, -50%) translateY(-50px) rotate(0deg);
    }
  }
  
  
  .bubble {
    position: absolute;
    background: #fff;
    color: #000;
    width: 200%;
    border: 1px solid #ccc;
    border-radius: 10px;
    padding: 10px;
    font-size: 14px;
    font-family: Arial, sans-serif;
    display: none;
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);
    z-index: 25;
  }
  
  .bubble:after {
    position: absolute;
    content: "";
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid #fff;
  }
  `, "",{"version":3,"sources":["webpack://./src/App/EducationCertifications.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,yDAA0C;EAC1C,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,aAAa;EACb,2BAA2B;EAC3B,yBAAyB;EAIzB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,+BAA+B;EAC/B,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB,EAAE,6BAA6B;EACjD,UAAU;EACV,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,SAAS,EAAE,wBAAwB;EACnC,2BAA2B,EAAE,qBAAqB;EAClD,UAAU;EACV,SAAS,EAAE,+BAA+B;AAC5C;;;EAGE;IACE,WAAW;IACX,WAAW;IACX,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,qCAAqC;IACrC,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,2CAA2C;IAC3C,kBAAkB;EACpB;;EAEA,4BAA4B;EAC5B;IACE,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,2CAA2C;EAC7C;EAGA;IACE,+BAA+B;IAC/B,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,wCAAwC;EAC1C;;EAEA,uBAAuB;EACvB;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,oBAAoB;IACpB,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,eAAe;IACf,eAAe;IACf,sBAAsB;IACtB,iBAAiB;IACjB,mDAAmD;IACnD,8BAA8B;EAChC;;EAEA,wCAAwC;EACxC;IACE;MACE,eAAe;MACf,gBAAgB;IAClB;;IAEA;MACE,eAAe;MACf,WAAW;MACX,YAAY;IACd;EACF;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,yCAAyC;IACzC,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,kDAAkD,EAAE,2BAA2B;IAC/E,WAAW;IACX,4CAA4C,EAAE,mBAAmB;EACnE;;EAEA;IACE;MACE,+DAA+D;IACjE;IACA;MACE,iEAAiE;IACnE;IACA;MACE,+DAA+D;IACjE;IACA;MACE,gEAAgE;IAClE;IACA;MACE,+DAA+D;IACjE;EACF;;;EAGA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,aAAa;IACb,2CAA2C;IAC3C,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,QAAQ;IACR,SAAS;IACT,mCAAmC;IACnC,oCAAoC;IACpC,2BAA2B;EAC7B","sourcesContent":["/* Section Styles */\r\n.section.num3 {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  cursor: none;\r\n  padding: 20px;\r\n  background-image: url('./images/Pmap.png');\r\n  background-size: cover;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n  height: 100vh;\r\n  -webkit-touch-callout: none;\r\n  -webkit-user-select: none;\r\n  -khtml-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n}\r\n.knife {\r\n  position: absolute;\r\n  pointer-events: none;\r\n  width: 80px;\r\n  transform-origin: bottom center;\r\n  transition: transform 0.3s ease;\r\n  z-index: 10001;\r\n}\r\n\r\n@keyframes knife-wave {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n  25% {\r\n    transform: rotate(-20deg);\r\n  }\r\n  50% {\r\n    transform: rotate(20deg);\r\n  }\r\n  100% {\r\n    transform: rotate(0deg);\r\n  }\r\n}\r\n\r\n.knife.wave {\r\n  animation: knife-wave 0.3s ease;\r\n}\r\n  \r\n.scroll-container {\r\n  position: absolute; /* Use absolute positioning */\r\n  width: 80%;\r\n  max-width: 600px;\r\n  top: 0;\r\n  height: 40%;\r\n  left: 50%; /* Center horizontally */\r\n  transform: translateX(-50%); /* Adjust centering */\r\n  z-index: 5;\r\n  margin: 0; /* Remove any existing margin */\r\n}\r\n\r\n  \r\n  .scroll-image {\r\n    width: 100%;\r\n    height: 35%;\r\n    display: block;\r\n    object-fit: top;\r\n  }\r\n  \r\n  .scroll-title {\r\n    position: absolute;\r\n    top: 20%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    font-family: 'Times New Roman', serif;\r\n    font-size: 150%;\r\n    font-weight: bold;\r\n    color: #5e3a1f;\r\n    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);\r\n    text-align: center;\r\n  }\r\n  \r\n  /* Symbol and Title Styles */\r\n  .symbol-container {\r\n    position: absolute;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    text-align: center;\r\n    z-index: 7;\r\n  }\r\n  \r\n  .symbol-title {\r\n    margin-bottom: 5px;\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n    color: #fff;\r\n    background-color: #8b0000;\r\n    padding: 4px 8px;\r\n    border-radius: 8px;\r\n    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);\r\n  }\r\n\r\n  @import url('https://fonts.googleapis.com/css2?family=Flavors&display=swap');\r\n  .x-symbol {\r\n    font-family: \"Flavors\", cursive;\r\n    font-weight: 400;\r\n    font-style: normal;\r\n    font-size: 45px;\r\n    color: #fff;\r\n    background-color: #8b0000;\r\n    width: 70px;\r\n    height: 70px;\r\n    border-radius: 50%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\r\n  }\r\n  \r\n  /* SVG and Red Curves */\r\n  .svg-container {\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;\r\n    top: 0;\r\n    left: 0;\r\n    pointer-events: none;\r\n    z-index: 5;\r\n  }\r\n  \r\n  .red-curve {\r\n    fill: none;\r\n    stroke: #ff4500;\r\n    stroke-width: 6;\r\n    stroke-dasharray: 4, 6;\r\n    stroke-opacity: 1;\r\n    filter: drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.7));\r\n    transition: d 0.2s ease-in-out;\r\n  }\r\n  \r\n  /* Media Queries for Responsive Design */\r\n  @media (max-width: 768px) {\r\n    .symbol-title {\r\n      font-size: 14px;\r\n      padding: 4px 8px;\r\n    }\r\n  \r\n    .x-symbol {\r\n      font-size: 40px;\r\n      width: 50px;\r\n      height: 50px;\r\n    }\r\n  }\r\n  \r\n  .popup-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100vw;\r\n    height: 100vh;\r\n    background: rgba(0, 0, 0, 0.7);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    z-index: 1000;\r\n  }\r\n  \r\n  .popup-card {\r\n    background: #121827;\r\n    padding: 20px;\r\n    border-radius: 10px;\r\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);\r\n    text-align: center;\r\n    position: relative;\r\n    color: #555;\r\n    font-size: 18px;\r\n  }\r\n  \r\n  .popup-card h2 {\r\n    margin-bottom: 10px;\r\n    color: #E4B300;\r\n    font-size: 34px;\r\n  }\r\n\r\n  .popup-card h3{\r\n    color: #fff;\r\n    margin-bottom: 5px;\r\n  }\r\n  \r\n  .popup-image {\r\n    width: 400px;\r\n    height: auto;\r\n    margin-bottom: 10px;\r\n    border-radius: 10px;\r\n    border: 2px solid #E4B300;\r\n  }\r\n  \r\n  .popup-card button {\r\n    background-color: #F4CC00;\r\n    color: white;\r\n    border: none;\r\n    padding: 10px 20px;\r\n    border-radius: 5px;\r\n    margin-top: 5px;\r\n  }\r\n  \r\n  .popup-card button:hover {\r\n    background-color: #E4B300;\r\n  }\r\n  \r\n  .ship {\r\n    position: absolute;\r\n    width: 100px;\r\n    transform: translate(-50%, -50%) translateY(-50px); /* Keeps the height fixed */\r\n    z-index: 20;\r\n    animation: ship-sway 2s ease-in-out infinite; /* Sway animation */\r\n  }\r\n  \r\n  @keyframes ship-sway {\r\n    0% {\r\n      transform: translate(-50%, -50%) translateY(-50px) rotate(0deg);\r\n    }\r\n    25% {\r\n      transform: translate(-50%, -50%) translateY(-50px) rotate(-10deg);\r\n    }\r\n    50% {\r\n      transform: translate(-50%, -50%) translateY(-50px) rotate(0deg);\r\n    }\r\n    75% {\r\n      transform: translate(-50%, -50%) translateY(-50px) rotate(10deg);\r\n    }\r\n    100% {\r\n      transform: translate(-50%, -50%) translateY(-50px) rotate(0deg);\r\n    }\r\n  }\r\n  \r\n  \r\n  .bubble {\r\n    position: absolute;\r\n    background: #fff;\r\n    color: #000;\r\n    width: 200%;\r\n    border: 1px solid #ccc;\r\n    border-radius: 10px;\r\n    padding: 10px;\r\n    font-size: 14px;\r\n    font-family: Arial, sans-serif;\r\n    display: none;\r\n    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);\r\n    z-index: 25;\r\n  }\r\n  \r\n  .bubble:after {\r\n    position: absolute;\r\n    content: \"\";\r\n    top: 100%;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    width: 0;\r\n    height: 0;\r\n    border-left: 10px solid transparent;\r\n    border-right: 10px solid transparent;\r\n    border-top: 10px solid #fff;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
